import { Insurance, InsuranceLimit } from '../data/models/insurance.model';

export enum InsuranceType {
  General = 1,
  Auto = 2,
}

export enum InsuranceCoverageType {
  AggregateLimit = 1,
  CombinedSingleLimit = 2,
  SplitLimits = 3,
}

export enum InsuranceLimitType {
  Aggregate = 1,
  Combined = 2,
  BodilyInjuryPerPerson = 3,
  BodilyInjuryPerAccident = 4,
  PropertyDamagePerAccident = 5,
}

class InsuranceUtils {
  public getInsurance(
    insurancePolicies: Insurance[] | undefined,
    type: InsuranceType,
  ): Insurance | undefined {
    return (insurancePolicies || []).find(
      (ins) => ins.insuranceTypeID === type,
    );
  }

  public getInsuranceLimit(
    insurance: Insurance | undefined,
    coverageType: InsuranceCoverageType,
    limitType: InsuranceLimitType,
  ): InsuranceLimit | undefined {
    return (insurance?.insuranceLimits || []).find(
      (limit) =>
        limit.insuranceCoverageTypeID === coverageType &&
        limit.insuranceLimitTypeID === limitType,
    );
  }
}

const insuranceUtils = new InsuranceUtils();

export default insuranceUtils;
